import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import usePartnerAuth from 'hooks/usePartnerAuth';
import Loader from 'components/Loader';
import { APP_DEFAULT_PATH } from 'config';

// ==============================|| GUEST GUARD — redirect authed users away from /login ||============================== //

export default function GuestGuard({ children }) {
  const { isAuthenticated, isInitializing } = usePartnerAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isInitializing && isAuthenticated) {
      navigate(APP_DEFAULT_PATH, { replace: true });
    }
  }, [isAuthenticated, isInitializing, navigate]);

  if (isInitializing) return <Loader />;

  return children;
}

GuestGuard.propTypes = { children: PropTypes.node };
